export const GET_USERS = "account/users";
export const DELETE_USER = "account/users/";
export const ADD_USER = "account/users/";
export const UPDATE_USER_NAME = "account/users/name";
export const GET_EXPORTERS = "account/exporter";
export const DELETE_EXPORTER = "account/exporter/";
export const ADD_EXPORTER = "account/exporter/";
export const UPDATE_EXPORTER = "account/exporter/";
export const ADD_AD_CODE = "account/exporter/adcode/";
export const DELETE_AD_CODE = "account/exporter/adcode/";
export const UPDATE_ACCOUNT_SETTINGS = "account/";
export const GET_ACCOUNT_DETAILS = "account/";
export const ADD_TIME_PERIOD = "account/timePeriods/create/";
export const GET_TIME_PERIODS = "account/timePeriods/show/";
export const DELETE_TIME_PERIOD = "account/timePeriods/delete/";
export const UPDATE_TIME_PERIOD = "account/timePeriods/update/";
export const ADD_NOTIFICATION_REQUEST = "account/";
